import instance from "api";
import {
  isV2Month,
  monthFromPlanDate,
  yearFromPlanDate,
} from "../huntersKpi/cutover";

const KPI_BASE = "/crm/kpi";

const fetchSdMonthPlan = (year, sd_id) => {
  const data = {year};
  if (sd_id) data.sale_department_id = sd_id;
  return instance(true)
    .get(`${KPI_BASE}/sd_month_plan/`, {params: data})
    .then((res) => res?.data || []);
};

/** Working План ОП: v2 only; drop pre-June rows as defense. */
export const getKpi = async (year, sd_id) => {
  const list = await fetchSdMonthPlan(year, sd_id);
  return (list || []).map((dept) => ({
    ...dept,
    plans: (dept.plans || []).filter((plan) => {
      const y = yearFromPlanDate(plan.sd_plan_month);
      const m = monthFromPlanDate(plan.sd_plan_month);
      return isV2Month(y, m);
    }),
  }));
};

export const getSaleDeptId = () => {
  return instance(true)
    .get(`/crm/sale_departments`)
    .then((res) => {
      return res?.data;
    });
};

export const addMonth = (year, sd_id, params) => {
  const y = params?.year || year;
  return instance(true)
    .post(
      `${KPI_BASE}/sd_month_plan/?year=${y}&sale_department_id=${sd_id}`,
      params
    )
    .then((res) => {
      return res?.data;
    });
};

export const changeKpi = (id, year, sd_id, params) => {
  return instance(true)
    .put(
      `${KPI_BASE}/sd_month_plan/${id}/?year=${year}&sale_department_id=${sd_id}`,
      params
    )
    .then((res) => {
      return res?.data;
    });
};
